module.exports = new __parcel__URL__("Commercial.a17be920.jpg").toString();